import React, { FunctionComponent } from 'react';
import { useRouter } from 'common-react';
import { useTranslation } from 'react-i18next';
import { GoBackButton } from 'ui-components';

const BackButton: FunctionComponent<{
  onBackButtonClick?: () => void;
  className?: string;
}> = ({ onBackButtonClick, className, ...props }) => {
  const [t] = useTranslation('product-wizard');
  const { history } = useRouter();

  return (
    <GoBackButton
      label={t('back-label')}
      className={className}
      {...props}
      onClick={() => {
        history.goBack();
        if (onBackButtonClick) {
          onBackButtonClick();
        }
      }}
    />
  );
};

export default BackButton;
